/* ============================================================
   BOUTON DE SAUVEGARDE RÉUTILISABLE
   Utilisé dans chaque étape du wizard
   ============================================================ */

interface SaveButtonProps {
  onSave: () => void;
  isSaving: boolean;
  disabled?: boolean;
}

export function SaveButton({ onSave, isSaving, disabled = false }: SaveButtonProps) {
  const isDisabled = isSaving || disabled;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        paddingTop: '1.5rem',
        marginTop: '1.5rem',
        borderTop: '2px solid #f0f0f0',
      }}
    >
      <button
        type="button"
        onClick={onSave}
        disabled={isDisabled}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          padding: '0.875rem 1.5rem',
          background: isDisabled ? '#e5e7eb' : '#00758d',
          color: isDisabled ? '#999' : 'white',
          border: 'none',
          borderRadius: '12px',
          fontSize: '0.95rem',
          fontWeight: 600,
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          boxShadow: isDisabled ? 'none' : '0 4px 12px rgba(0,117,141,0.3)',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={(e) => {
          if (!isDisabled) {
            e.currentTarget.style.background = '#005a6d';
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,117,141,0.4)';
          }
        }}
        onMouseLeave={(e) => {
          if (!isDisabled) {
            e.currentTarget.style.background = '#00758d';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,117,141,0.3)';
          }
        }}
      >
        {isSaving ? (
          <svg
            className="animate-spin"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
          </svg>
        ) : (
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
            <polyline points="17 21 17 13 7 13 7 21" />
            <polyline points="7 3 7 8 15 8" />
          </svg>
        )}
        {isSaving ? 'Sauvegarde...' : 'Sauvegarder'}
      </button>
    </div>
  );
}
